import { Component, OnInit } from '@angular/core';
import { TooltipMessage } from './flow-states-tooltip.interface';
import { Store } from '@ngrx/store';
import { StoreState } from '@/store';
import { transition, trigger, style, animate } from '@angular/animations';

@Component({
  selector: 'app-flow-states-tooltip',
  templateUrl: './flow-states-tooltip.component.html',
  styleUrls: ['./flow-states-tooltip.component.css'],
  animations: [
    trigger(
      'inOutAnimation',
      [
        transition(
          ':enter',
          [
            style({ opacity: 0 }),
            animate(50, style({  opacity: 1 })),
          ],
        ),
        transition(
          ':leave',
          [
            style({ opacity: 1 }),
            animate(50, style({  opacity: 0 })),
          ],
        ),
      ],
    ),
  ],
})
export class FlowStatesTooltipComponent implements OnInit {

  tooltips: TooltipMessage[] = [];

  constructor(
    private store: Store<StoreState>,
  ) {
    this.store.select('flowStatesTooltip').subscribe({
      next: (tooltipMessages) => {
        this.tooltips = tooltipMessages;
      },
    });
  }

  ngOnInit(): void {
  }

}
